import {Product} from '@hassel-it/shop-services';
import {PriceAdjustment} from "./price-adjustment";
import {PriceRobotUrl, PriceRobotUrlInterface} from "./price-robot-url";

export class PriceRobotProduct extends Product {

    crawler_urls: PriceRobotUrl[] = [];
    price_adjustment: PriceAdjustment;
    results: any[];
    image_url: string;

    static customFromJSON(data) {
        const product = this.fromJSON(data, new PriceRobotProduct());
        if (data.crawler_urls) {
            data.crawler_urls.forEach((value: PriceRobotUrlInterface, index) => {
                product.crawler_urls.push(PriceRobotUrl.fromJSON(value));
            });
        }
        if (data.price_adjustment) {
            product.price_adjustment = PriceAdjustment.fromJSON(data.price_adjustment);
        }

        if (data.results) {
            product.results = data.results;
        }
        if (data.image_url) {
            product.image_url = data.image_url;
        }

        return product;
    }

    findIndex(key: string): number {
        return this.custom_fields.findIndex(function (field: any) {
            return field.key == key;
        });
    }

    /**
     * Url har fejl (minus udsolgt - og transient)
     */
    hasError(): boolean {
        for (const crawlerUrl of this.crawler_urls) {
            if (crawlerUrl.has_error && !this.checkErrorTransient(crawlerUrl.last_error)) {
                return true;
            }
        }
        return false;
    }

    /**
     * Check om fejlen er transient - eller udsolgt
     */
    checkErrorTransient(error): boolean {
        if (!/out of stock/i.test(error)
            && !/deliveryReenque/i.test(error)
            && !/no such element/i.test(error)
            && !/stale element/i.test(error)
            && !/Could not start a new session/i.test(error)
            && !/curl error thrown for http/i.test(error)
        ) {
            return false;
        }
        return true;
    }
}
